import { useCallback, useMemo } from 'react'
import { generatePath, Link, useParams } from 'react-router-dom'
import { Space, Button } from 'antd'
import * as Icons from '@ant-design/icons'
import { useApiQuery } from 'admin/lib/Api'
import { Layout } from 'admin/lib/Layouts'
import { Breadcrumb, BreadcrumbArrayItem } from 'admin/lib/Breadcrumbs'
import { ScreenSpin } from 'admin/lib/ScreenSpin'
import * as ROUTES from 'admin/routes'
import { GetPageNames } from 'admin/lib/GetPageNames'

import { ConnectionList } from './ConnectionList'

export function Connections() {
  const { accountId, projectId } = useParams()

  const account = useApiQuery(
    useCallback(api => api.getAccount(accountId), [accountId])
  )
  const project = useApiQuery(
    useCallback(
      api => api.getProject(accountId, projectId),
      [accountId, projectId]
    )
  )

  const context = useMemo(() => {
    return {
      loaded: account.loaded && project.loaded,
      account: account.data,
      project: project.data
    }
  }, [account.data, account.loaded, project.data, project.loaded])

  const connections = useApiQuery(
    useCallback(
      api => {
        return api.listConnections(accountId, projectId)
      },
      [accountId, projectId]
    )
  )
  const pageNames = GetPageNames(accountId, projectId, null)

  return (
    <Layout
      header={
        <>
          <Breadcrumb
            items={[
              {
                title: (
                  <BreadcrumbArrayItem
                    href={generatePath(ROUTES.ACCOUNTS.LIST)}
                  >
                    Accounts
                  </BreadcrumbArrayItem>
                )
              },
              {
                title: (
                  <BreadcrumbArrayItem
                    loading={!context.loaded}
                    href={generatePath(ROUTES.PROJECTS.LIST, {
                      accountId: accountId
                    })}
                  >
                    {pageNames.data && pageNames.data.accountName}
                  </BreadcrumbArrayItem>
                )
              },
              {
                title: (
                  <BreadcrumbArrayItem
                    href={generatePath(ROUTES.PROJECTS.LIST, {
                      accountId: accountId
                    })}
                  >
                    Projects
                  </BreadcrumbArrayItem>
                )
              },
              {
                title: (
                  <BreadcrumbArrayItem loading={!context.loaded}>
                    {pageNames.data && pageNames.data.projectName}
                  </BreadcrumbArrayItem>
                )
              },
              {
                title: 'Connections'
              }
            ]}
          />

          <Space>
            <Link
              to={generatePath(ROUTES.CONNECTIONS.NEW, {
                accountId: accountId,
                projectId: projectId
              })}
            >
              <Button type="primary" icon={<Icons.FormOutlined />}>
                New
              </Button>
            </Link>
          </Space>
        </>
      }
    >
      {!connections.loaded && <ScreenSpin />}

      {connections.error && (
        <div>
          Something went wrong:{' '}
          {String(connections.error.response?.data ?? connections.error)}
        </div>
      )}

      {connections.loaded && connections.data && (
        <ConnectionList
          connections={connections.data}
          accountId={accountId}
          projectId={projectId}
        />
      )}
    </Layout>
  )
}
